import { useState } from 'react';
import Drawer from 'components/gruenland/atoms/drawer/Drawer';
import { Menu } from 'components/gruenland/icons/Menu';
import { useFormat } from 'helpers/hooks/useFormat';
import { Category } from 'types/entity/category';
import MobileMenuContent from './content/MobileMenuContent';
import MobileMenuHeader from './content/MobileMenuHeader';
import { Tile } from '../../types';

export interface Props {
  links: Category[];
  tiles: Tile[];
}

const HeaderNavigationMobile: React.FC<Props> = ({ links, tiles }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const [categoriesNavigator, setCategoriesNavigator] = useState<Category[]>([]);
  const [showMenu, setShowMenu] = useState(false);

  const showHeaderMenu = () => {
    setShowMenu(true);
  };

  const hideHeaderMenu = () => {
    setShowMenu(false);
    setCategoriesNavigator([]);
  };

  const removeCategory = () => {
    setCategoriesNavigator((array) => array.slice(0, -1));
  };

  const insertCategory = (category: Category) => {
    setCategoriesNavigator((array) => [...array, category]);
  };

  return (
    <div className="md:hidden">
      <button
        onClick={showHeaderMenu}
        title={formatMessage({ id: 'common.openSideMenu', defaultMessage: 'Apri il menu laterale' })}
      >
        <Menu />
      </button>

      <Drawer isOpen={showMenu} direction="left" className="w-4/5" onClose={hideHeaderMenu}>
        <MobileMenuHeader
          categories={categoriesNavigator}
          hideHeaderMenu={hideHeaderMenu}
          onArrowClick={removeCategory}
        />

        <MobileMenuContent
          links={links}
          hideHeaderMenu={hideHeaderMenu}
          categoriesNavigator={categoriesNavigator}
          insertCategory={insertCategory}
          tileContent={tiles}
        />
      </Drawer>
    </div>
  );
};

export default HeaderNavigationMobile;
